<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="6")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              VehicleAttributeButtons(:item="item")
          .field-value(slot="n1") VA{{item.id}}
          .field-value(slot="n2") {{item.name}}
          .field-value(slot="n2") {{item.description}}
          .field-value(slot="n3") VT{{item.vehicle_type.id}}
          .field-value(slot="n3") {{item.vehicle_type.name}}
          .field-value(slot="n4") Type:
          .field-value(slot="n4") {{item.type}}
          .field-value(slot="n5") Private: {{item.private}}
          .field-value(slot="n5") Recommended: {{item.recommended}}
          .field-value(slot="n6")
            template(v-if="item.icon")
              MdiIcon(:name="item.icon")
          .field-url-detail(slot="actionPage")
            router-link(:to="{name:'attribute', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
    .card( v-if="$is('entityList')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="3")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              VehicleAttributeButtons(:item="item", :vehicle="true")
          .field-value(slot="n1") IN{{item.id}}
          .field-value(slot="n2") {{item.instruction.title}}
          .field-value(slot="n2") {{item.instruction.subtitle}}
          .field-value(slot="n3") N° of steps
          .field-value(slot="n3") {{item.instruction.steps.length}}
          .field-url-detail(slot="actionPage")
            router-link(:to="{name:'instruction', params:{id:item.instruction.id}}")
              i.fa.fa-angle-right.fa-3x.action
</template>
<script type="text/babel">
import CardN from 'components/structure/CardN'
import Dropdown from '../structure/foundation/Dropdown'
import InstructionButtons from "../structure/ui/actions/InstructionButtons";
import VehicleAttributeButtons from '../structure/ui/actions/VehicleAttributeButtons'
import MdiIcon from "../structure/ui/MdiIcon.vue";

export default {
  name: "Instruction",
  components: {
    MdiIcon,
    VehicleAttributeButtons,
    InstructionButtons,
    Dropdown,
    CardN,
  },
  data() {
    return {}
  },
  created() {

  },
  methods: {},
  computed: {},
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// VehicleAttribute.vue?28099b14